export default __webpack_public_path__ + "static/media/qrcodelogo2.ededa746.png";